module.exports = __webpack_public_path__ + "static/4-c3c641d8aa9ca28f0c0121efa422a235.jpg";